/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { JobSitemapEntry } from './';
import {
    JobSitemapEntryFromJSON,
    JobSitemapEntryFromJSONTyped,
    JobSitemapEntryToJSON,
} from './';

/**
 * 
 * @export
 * @interface CategorySitemapEntry
 */
export interface CategorySitemapEntry {
    /**
     * 
     * @type {string}
     * @memberof CategorySitemapEntry
     */
    categoryLabel: string;
    /**
     * 
     * @type {string}
     * @memberof CategorySitemapEntry
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof CategorySitemapEntry
     */
    url: string;
    /**
     * 
     * @type {Array<JobSitemapEntry>}
     * @memberof CategorySitemapEntry
     */
    jobSitemapEntries?: Array<JobSitemapEntry>;
}

/**
 * Check if a given object implements the CategorySitemapEntry interface.
 */
export function instanceOfCategorySitemapEntry(value: object): value is CategorySitemapEntry {
    if (!('categoryLabel' in value) || value['categoryLabel'] === undefined) return false;
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function CategorySitemapEntryFromJSON(json: any): CategorySitemapEntry {
    return CategorySitemapEntryFromJSONTyped(json, false);
}

export function CategorySitemapEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategorySitemapEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryLabel': json['categoryLabel'],
        'categoryId': json['categoryId'],
        'url': json['url'],
        'jobSitemapEntries': json['jobSitemapEntries'] == null ? undefined : ((json['jobSitemapEntries'] as Array<any>).map(JobSitemapEntryFromJSON)),
    };
}

export function CategorySitemapEntryToJSON(value?: CategorySitemapEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'categoryLabel': value['categoryLabel'],
        'categoryId': value['categoryId'],
        'url': value['url'],
        'jobSitemapEntries': value['jobSitemapEntries'] == null ? undefined : ((value['jobSitemapEntries'] as Array<any>).map((v) => JobSitemapEntryToJSON(v))),
    };
}

